import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '@app/core/okta-auth.guard';
import { ContractorDashboardComponent } from './contractor-dashboard/contractor-dashboard.component';

const routes: Routes = [
  {
    path: 'vendor-employee',
    canActivate: [AuthGuard],
    children: [{ path: '', component: ContractorDashboardComponent }],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ContractorFlowRoutingModule {}
